<form lin-layout-form [formGroup]="form" (ngSubmit)="submitForm()">
  <lin-form-label required>{{ 'CLIENT.VEHICLES.SERVICE_REMINDERS.SERVICE_DATE' | translate }}</lin-form-label>
  <lin-datepicker-field formControlName="date" [isPlaceholderShown]="true" [isNoMaxDate]="true"></lin-datepicker-field>

  <lin-form-label [required]="data?.odometer">{{ 'FIELDS.odometer' | translate }}</lin-form-label>
  <mat-form-field>
    <input matInput formControlName="odometer" autocomplete="off" />
    <mat-error>
      <lin-form-field-error [control]="form.get('odometer')" controlName="odometer"></lin-form-field-error>
    </mat-error>
  </mat-form-field>

  <lin-form-label [required]="data?.engineHours">{{ 'FIELDS.engineHours' | translate }}</lin-form-label>
  <mat-form-field>
    <input matInput formControlName="engineHours" autocomplete="off" />
    <mat-error>
      <lin-form-field-error></lin-form-field-error>
    </mat-error>
  </mat-form-field>

  <lin-form-label class="cost" [currencyLabel]="true">{{ 'CLIENT.VEHICLES.SERVICE_REMINDERS.COST' | translate }}</lin-form-label>
  <mat-form-field>
    <input matInput formControlName="cost" type="number" min="0" autocomplete="off" />
    <mat-error><lin-form-field-error></lin-form-field-error></mat-error>
  </mat-form-field>

  <lin-form-label>{{ 'FIELDS.NOTE' | translate }}</lin-form-label>
  <mat-form-field>
    <textarea matInput rows="7" formControlName="note"></textarea>
  </mat-form-field>

  <lin-form-file-picker formControlName="files">
    @if (data?.files) { @for (file of (data?.files); track file.id) { @if (!form.get('removeFiles').value.includes(file.id)) {
    <lin-form-file-row name="{{ file.displayName }}" url="{{ file.path + file.name }}" (delete)="removeFile(file.id)"></lin-form-file-row>
    } } }
  </lin-form-file-picker>

  <lin-layout-form-toolbar-info>
    <lin-layout-form-toolbar-info-row>
      <lin-layout-form-toolbar-info-label> {{ 'ADMIN.DEVICES.CREATED' | translate }}: </lin-layout-form-toolbar-info-label>
      <lin-layout-form-toolbar-info-value>
        {{ data.createdAt | dayjsDateTime }} {{ data.createdBy && ('USER.BY' | translate) }} {{ data.createdBy.fullName }}
      </lin-layout-form-toolbar-info-value>
    </lin-layout-form-toolbar-info-row>

    <lin-layout-form-toolbar-info-row>
      <lin-layout-form-toolbar-info-label>{{ 'ADMIN.DEVICES.LAST_UPDATED' | translate }}: </lin-layout-form-toolbar-info-label>
      <lin-layout-form-toolbar-info-value>
        {{ (data.updatedAt | dayjsDateTime) || '-' }} {{ data.updatedBy && ('USER.BY' | translate) }} {{ data.updatedBy?.fullName }}
      </lin-layout-form-toolbar-info-value>
    </lin-layout-form-toolbar-info-row>
  </lin-layout-form-toolbar-info>
  <lin-form-submit-button class="edit-record-button" [isLoading]="false"
    >{{ 'CLIENT.VEHICLES.DOCUMENTS.EDIT_RECORD' | translate }}</lin-form-submit-button
  >
</form>
